var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-report"},[(_vm.isPause)?_c('div',{staticClass:"yinyue-pause",on:{"click":_vm.startOrPause}}):_vm._e(),_c('audio',{attrs:{"autoplay":"","loop":"","id":"music","src":'https://h5.hunteron.com/music/yearbg12.mp3'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }